import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { openChat } from "./store";
import ProfileCircle from "@/pages/chat/ProfileCircle";
import {useNavigate} from "react-router-dom";
import {timeAgo} from "@/utils/utils";
import ReactCountryFlag from "react-country-flag"
import {Icon} from "@/components/Icon.tsx";

export interface Conversation {
  id: string
  updated_at: number
  last_message_at: number
  last_user_message: string
  geo: any
  device: any
  unread_messages: number
  unknown_questions: number
  visitor_data: {[key : string]: string}
}

const Contact = ({ contact } : { contact : any}) => {
  contact = contact as Conversation
  const { fullName, avatar, status, lastmessage, unredmessage } = contact;

  const dispatch = useDispatch();
  const navigate = useNavigate()

  const {user} = useSelector((state : any) => state.chat);

  let active = contact?.id === user?.id

  let name = "Name" in contact.visitor_data ? contact.visitor_data["Name"] : "Visitor"
  let email = "Email" in contact.visitor_data ? contact.visitor_data["Email"] : null

  let bracketsData = ""
  bracketsData = email ? email : (contact.geo?.country ? contact.geo.country : null)
  let visitorTitle = `${name} ${bracketsData ? `(${bracketsData})` : ""}`

  return (
    <div
      className={"block w-full py-5 focus:ring-0 outline-none cursor-pointer group transition-all duration-150 hover:bg-slate-100 dark:hover:bg-slate-600 dark:hover:bg-opacity-70 border-b-slate-100 border-b-2 " + (active ? "bg-slate-100" : "")}
      onClick={() => {
        navigate(contact.id);
        dispatch(
          openChat({
            contact,
            activechat: true,
          }),
        );
      }}
    >
      <div className="flex space-x-3 px-6 rtl:space-x-reverse">
        <div className="flex-none">
          <div className="h-10 w-10 rounded-full relative">
            <span
              className={`  status ring-1 ring-white inline-block h-[10px] w-[10px] rounded-full absolute right-0 top-0
                ${status === "active" ? "bg-success-500" : "bg-secondary-500"}
              `}
            ></span>
            <div className="absolute bottom-[-8px] right-[-6px]">

            </div>
            <ProfileCircle contact={contact} />
          </div>
        </div>
        <div className="flex-1 text-start flex">
          <div className="flex-1">
            <span className="block text-slate-800 dark:text-slate-300 text-sm font-medium mb-[2px] flex items-center">
              {contact.geo?.country_code &&
                <ReactCountryFlag countryCode={contact.geo?.country_code} className="mr-1" title={contact.geo?.country} />
              }
              {visitorTitle}
            </span>
            <span className="block text-slate-600 dark:text-slate-300 text-xs font-normal">
              {contact.last_user_message.length > 30 ? (contact.last_user_message.slice(0, 30) + "...") : contact.last_user_message}
            </span>
          </div>
          <div className="flex-none ltr:text-right rtl:text-end">
            <span className="block text-xs text-slate-400 dark:text-slate-400 font-normal">
              {contact.last_message_at ? timeAgo(new Date(contact.last_message_at*1000)) : ""}
            </span>
            <div className="">
              {contact.unknown_questions > 0 && (
                  <span title="Unknown question">
                    <Icon
                        icon="fluent:warning-32-regular"
                        width="1.2rem"
                        className="inline-block text-sky-500 mr-1"
                    />
                  </span>
              )}
              {contact.unread_messages > 0 && (
                  <span className="inline-flex flex-col items-center justify-center text-[10px] pt-0.5 px-1 font-medium h-4 min-w-[1rem] bg-slate-400 text-white rounded-full">
                {contact.unread_messages}
              </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
